// extracted by mini-css-extract-plugin
module.exports = {"settings":"styles__settings___1KaHA","settingsIcon":"styles__settingsIcon___zjDLK"};